import { WOOT_PREFIX } from './constants';

export const isEmptyObject = obj =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const sendMessage = msg => {
  window.parent.postMessage(
    `chatwoot-widget:${JSON.stringify({ ...msg })}`,
    '*'
  );
};

export const IFrameHelper = {
  isIFrame: () => window.self !== window.top,
  sendMessage,
  isAValidEvent: e => {
    const isDataAString = typeof e.data === 'string';
    return isDataAString && e.data.indexOf(WOOT_PREFIX) === 0;
  },
  getMessage: e => JSON.parse(e.data.replace(WOOT_PREFIX, '')),
};
export const RNHelper = {
  isRNWebView: () => window.ReactNativeWebView,
  sendMessage: msg => {
    window.ReactNativeWebView.postMessage(
      `chatwoot-widget:${JSON.stringify({ ...msg })}`
    );
  },
};

export const groupBy = (array, predicate) => {
  return array.reduce((acc, value) => {
    (acc[predicate(value)] ||= []).push(value);
    return acc;
  }, {});
};

export const addHashToUrl = (url = '', insertBefore = false) => {
  if (process.env.NODE_ENV === 'development') {
    return url;
  }

  const hash = process.env.BACKEND_HASH_URL;
  if (!hash || url.includes(hash)) {
    return url;
  }

  return insertBefore ? `/${hash}/${url}` : `${url}/${hash}`;
};

export const isMobile = () => {
  const match = window.matchMedia || window.msMatchMedia;
  if (match) {
    const mq = match('(pointer:coarse)');
    return mq.matches;
  }
  return false;
};
